import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useQueryParamsReducer = () =>
  useSelector((state: ApplicationState) => state.queryParams);
